import { Component, HostListener, Input, OnChanges } from '@angular/core';
import { ButtonSize } from '@com-delta-idp/mnx-ui-kit';
import { Onboarding } from './models/onboarding.interfaces';

@Component({
  selector: 'idp-onboarding',
  templateUrl: './onboarding.component.html',
  styleUrls: ['./onboarding.component.scss']
})
export class OnboardingComponent implements OnChanges {
  @Input() content: Onboarding = {} as Onboarding;

  buttonSize: ButtonSize = 'wide';
  display = true;

  ngOnChanges() {
    this.buttonSize = this.getButtonSize(window.innerWidth);
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: Event) {
    const width = event && (event.target as Window);
    this.buttonSize = this.getButtonSize(width.innerWidth);
  }

  getButtonSize(width: number): ButtonSize {
    return width < 768 ? 'full-width' : 'wide';
  }

  redirect(link: string | undefined) {
    window.open(link);
  }
}
